import { Route } from "react-router-dom";
import { Suspense } from "react";
import type { RouteConfig } from "./config";
import { ProtectedRoute } from "./guards";
import { DashboardLayoutRoute } from "./layouts";
import { OnboardingGate } from "@/components/training/onboarding-gate";
import { LoadingPage } from "@/components/ui/loading-page";

/**
 * Transforms declarative RouteConfig[] into React Router Route elements.
 * Guard -> Layout -> OnboardingGate -> Suspense -> Component
 */
export const buildRoutes = (configs: RouteConfig[]) => {
  return configs.map((config) => {
    const Component = config.component;

    let element = (
      <Suspense fallback={<LoadingPage />}>
        <Component />
      </Suspense>
    );

    if (config.layout === "dashboard") {
      element = (
        <OnboardingGate>
          <DashboardLayoutRoute>{element}</DashboardLayoutRoute>
        </OnboardingGate>
      );
    }

    element = (
      <ProtectedRoute permissions={config.permissions}>
        {element}
      </ProtectedRoute>
    );

    return <Route key={config.path} path={config.path} element={element} />;
  });
};
